
import React, { useEffect, useState, useCallback } from "react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";
import { Table, Tooltip } from "antd";
import {
  onShowSizeChange,
  itemRender,
  showTotal
} from "../_components/paginationfunction";
//import Data from "../assets/jsons/vendors";
import {formatNumberWithCustomSymbol} from '../assets/salaryformat';
import api from "../api/api"
import { Link } from "react-router-dom";
import Filter from "./Filter"
import { filterIcon } from "../_components/Imagepath";
import { useAuth } from "../context/AuthContext";
import Broadcast from "./Broadcast";
import Share from "./Share";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import * as Icon from 'react-feather';
import AllBiodataMobile from "./AllBiodataMobile"
import SearchCard from "./SearchCard"
import BookEmployerBiodataShared from "../employers/BookEmployerBiodataShared";
import ConfirmPublish from "./ConfirmPublish";
import { useTranslation } from 'react-i18next';
export const fetchVendorIdSidebar = async(setVendors) => {
try {
      const response = await api.get('/agency-vendor-list');

      if (response.status === 200 && Array.isArray(response.data.data)) {
        setVendors(response.data.data);
        localStorage.setItem("sideBarVendor", JSON.stringify(response.data.data));
      }
    } catch (error) {
      console.error("Error fetching agencies:", error);
    } 
}
const BiodataForm = () => {

  const { user } = useAuth()
  const { t } = useTranslation();

  const [clickedBiodata, setclickedBiodata] = useState(null);
  const [selectedBiodata, setSelectedBiodata] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [employer, setEmployer] = useState("");
  
  const [employers, setEmployers] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [menu, setMenu] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [error, setError] = useState(null);
  const [pageTitle, setPageTitle] = useState(t("All Biodata"));
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [isBookOpen, setIsBookOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);

  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);


  const vendorId = searchParams.get('vendor_id'); // will be a string


  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };


  const fetchDataEmployers = async () => {
    if (user.type !== "agency") return; // Only fetch if user is an agency
    try {
      const response = await api.get("/get-employer");
      setEmployers(response.data.employers);
    } catch (error) {
      // Extract response code if available
      const responseCode = error.response ? error.response.status : "Unknown";
      console.log("Response Code:", responseCode);
      if (error?.response?.data) {
        Object.entries(error.response.data).forEach(([key, values]) => {
          console.log(key, values);
        }
        );
      }
    }
  }


    const fetchData = async (page = 1, searchKeyword = keyword, employerParam = employer) => {
      setLoadingForm(true)
      setError(null)

      try {
        let typeurl = "";

        if (user.type === "agency" && vendorId !== null) {
          typeurl = "/supplier-biodata-shared/";
        } else if (user.type === "agency") {
          typeurl = "/agency-biodata/";
        } else if (user.type === "supplier" && vendorId !== null) {
          typeurl = "/vendor-agency-biodata/";
        } else if (user.type === "supplier") {
          typeurl = "/supplier-biodata/";
        } else {
          return;
        }

        const params = user.type === "agency" && vendorId !== null ? { vendor_id: vendorId } : {};
        
        // Add search parameter if keyword exists
        if (searchKeyword && searchKeyword.trim() !== "") {
          params.search = searchKeyword.trim();
        }
        if (employerParam) {
          params.employer = employerParam;
        }
        
        // get all params from URL
        for (const [key, value] of searchParams.entries()) {
          if (key !== 'search') { // Avoid duplicate search param
            params[key] = value;
          }
        }

        const response = await api.get(typeurl + `?page=${page}`, {
          params: params
        });

        // Handle success based on status code
        if (response.status === 200 || response.status === 201) {
          if (Array.isArray(response.data.results)) {
            const showdData = response.data.results.map(({ children, ...rest }) => ({
              enfants: children,
              ...rest,
            }));
          
            setData(showdData)
            setNextPage(response.data.next);
            setPrevPage(response.data.previous);
            setCount(response.data.count);
          } else {
            console.error("Data is not an array:", response.data);
            setError(response.status)
          }
        }

      } catch (error) {
        console.error("API Error:", error);

        if (error.response) {
          console.log("Error Status:", error.response.status);
          const responseCode = error.response.data.detail ? error.response.data.detail : "Unknown";
          setError(responseCode)
          setError(error.response.status);
        } else if (error.request) {
          console.log("No response received:", error.request);
          setError("No response from server");
        } else {
          console.log("Error setting up request:", error.message);
          setError("Request setup error");
        }
      } finally {
        setLoadingForm(false);
      }
    }

  useEffect(() => {
    fetchData();
  }, []);

  const handlePageChange = (page) => {
    if (page < 1 || page > Math.ceil(count / 10)) {
      return; // Prevent invalid page changes
    }
    setCurrentPage(page);
    fetchData(page);
  };

  const fetchDataVendors = useCallback(async () => {
    console.log("Fetching agencies...");
    fetchVendorIdSidebar(setVendors);
    /*try {
      const response = await api.get('/agency-vendor-list');

      if (response.status === 200 && Array.isArray(response.data.data)) {
        setVendors(response.data.data);
        localStorage.setItem("sideBarVendor", JSON.stringify(response.data.data));
      }
    } catch (error) {
      console.error("Error fetching agencies:", error);
    }*/
  }, []);


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    if(user.type === "agency"){
      fetchDataVendors();
      fetchDataEmployers();
    }
    
  }, [user.type, fetchDataVendors]);

  useEffect(() => {
    setCurrentPage(1);
    fetchData(1);

    let vendorName = vendors.find((vendor) => vendor.id === parseInt(vendorId));
    if (vendorName) {
      setPageTitle(vendorName.name);
    } 
    else if (user.type === "agency" && searchParams.has("agency_id")) {
      setPageTitle(localStorage.getItem("company_name"));
    } else if (user.type === "supplier" && searchParams.has("vendor_id")) {
      setPageTitle("Shared Biodata - " + searchParams.get("agency_name") + " (agency) | " + searchParams.get("vendor_name") + " (vendor)");
    } 
    else {
      setPageTitle(t("All Biodata"));
    }

  }, [vendorId, location.search])

const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();


    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age;
  }
  const parseDMYToDate = (dmy) => {
    const [day, month, year] = dmy.split("/");

    return new Date(`${year}-${month}-${day}`);
  }


  // Add search input change handler (for typing)
  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setKeyword(value);
  };

  const handleEmployerChange = (e) => setEmployer(e.target.value);


  // Add search submit handler (for button click)
  const handleSearchSubmit = (e) => {
    e.preventDefault(); // Prevent form submission
    setCurrentPage(1); // Reset to first page when searching
    fetchData(1, keyword, employer);
  };

  // Add clear search function
  const handleClearSearch = () => {
    console.log("Clearing search");
    setKeyword("");
    setEmployer("");
    setCurrentPage(1)
    fetchData(1, "", "");
  };

  const columns = [
    ...((user.type == "agency" && user.company.is_premium) ? [
      {
        title: (
          <button 
            className="btn btn-sm btn-outline-primary" 
            data-bs-toggle="modal" 
            data-bs-target="#share_modal" 
            disabled={selectedBiodata.length === 0}
            onClick={() => setIsShareOpen(true)}
          >
            <Icon.Share2 className="me-1" size={14} /> {t("Share")}
          </button>
        ),
        dataIndex: "id",
        render: (value, record) => {
          const uniqueId = `${record.agency ? "agency" : "vendor"}-${value}`;

          const isChecked = selectedBiodata.some(
            (item) => item.id === value && item.is_agency === (record.agency ? true : false)
          );

          return (
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                style={{ borderColor: "#8e7b7b" }}
                id={uniqueId}
                value={value}
                checked={isChecked}
                onChange={(e) => {
                  if (e.target.checked) {
                    setIsShareOpen(true);
                    setSelectedBiodata((prev) => [
                      ...prev,
                      { id: value, is_agency: record.agency ? true : false },
                    ]);
                  } else {
                    setSelectedBiodata((prev) =>
                      prev.filter(
                        (item) =>
                          !(
                            item.id === value &&
                            item.is_agency === (record.agency ? true : false)
                          )
                      )
                    );
                  }
                }}
              />
            </div>
          )
        },
      }
    ] : []),
    {
      title: t("Action"),
      dataIndex: "Action",
      render: (_, record) =>{ 
        let isBiodataOwner = false;
        if (user.type == "supplier") {
          isBiodataOwner = record.supplier ? true : false;
        } else if (user.type == "agency") {
          isBiodataOwner = record.agency ? true : false;
        }

        return(


        <div className="d-flex align-items-center">
          {/*<Link to="/ledger" */}
          {/* <Link to={{
            pathname: "/biodata/" + record.id,
            state: { profile: record },
          }} className="btn btn-greys me-2">
             <i className="fa fa-eye me-1" /> View
          </Link> */}


          {
            user.type == "supplier" && (
              <>
                <button className="btn btn-greys me-2" data-bs-toggle="modal" data-bs-target="#broadcast_modal" onClick={() => setclickedBiodata(record)} disabled={record.status != "Published"}>
                  <Icon.Send /> {t("Broadcast")}
                </button>
              </>
            )
          }

          {
            user.type == 'agency' && record.status == "Published" && user.company.is_premium && (
              <div>
                <button
                    type="button"
                    className="btn btn-greys me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#book_biodata_dialog"
                    onClick={() => {setclickedBiodata(record); setIsBookOpen(true)}}
                    disabled={!record.booking_status && record.is_have_booking}
                    >
                      
                    {!record.booking_status && record.is_have_booking ? 
                  (
                    <>
                      <Icon.PauseCircle /> {t("On Hold")}
                    </>
                  ) : (
                    <>
                      <Icon.Mic /> {t("Book")}
                    </>
                  )
                  }
               </button>
              </div>
            )
          }

          {
            isBiodataOwner && record.status == "Draft" && (
              <button 
                type="button"
                className="btn btn-greys me-2"
                data-bs-toggle="modal"
                data-bs-target="#modal_publish"
                onClick={() => setclickedBiodata(record)}
                >
                <Icon.Activity /> {t("Publish")}
              </button>
            )
          }
          

          


        </div>

      )},
      //sorter: (a, b) => a.Action.length - b.Action.length,
    },
    {
      title: t("Name"),
      dataIndex: "name",
      render: (value,record) => (

        <h2 className="table-avatar">
          <Link to={{
        pathname: "/biodata/" + record.id,
        state: { profile: record },
        }} className="avatar-biodata me-2">
          {record.imgprofile ? (
            <img
              className="avatar-img rounded"
              src={record.imgprofile}
       
              alt="User"
            />
          ) : (
           
            <div style={{width:"100px",height:"100px",alignContent: "center",textAlign:"center"}}>
              <i className="fas fa-user text-muted" style={{ fontSize: "50px" }}></i>
            </div>
          )}
          </Link>
          <Link to={{
        pathname: "/biodata/" + record.id,
        state: { profile: record },
        }}>
            {record.name} <span>

             {user.type == "supplier" ? record.code : (record.supplier_name ? record.supplier_name : (localStorage.getItem("company_name") ? localStorage.getItem("company_name") : t("All Biodata")))} 
               
               </span>
          </Link>
        </h2>

      ),
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
    },
    ...(user.type == "agency" ? [{
      title: t("Code"),
      dataIndex: "code",
      render: (value) =>  value,
      sorter: false,
    }] : []),
   
    {
      title: t("Status"),
      dataIndex: "status",
      render: (value) => {
        let colorClassStatus=""
        if (value === "Published") colorClassStatus = "bg-success-light";
        else if (value === "Draft") colorClassStatus = "bg-info";
        else if (value === "On-Hold") colorClassStatus = "bg-light border text-black";
        else if (value === "Booked") colorClassStatus = "bg-primary-light";
        else if (value === "Unavailable") colorClassStatus = "bg-dark";
        else if (value === "Removed") colorClassStatus = "bg-danger text-white";
          return(<div>
            <span className={`badge badge-pill ${colorClassStatus}`} >{value}</span> 
             
          </div>)
      },
      sorter: (a, b) => (a.status || '').localeCompare(b.status || ''),
  },
    {
      title: t("Nationality"),
      dataIndex: "nationality",
      render: (value) => value ? t(value) : "N.A",
      sorter: (a, b) =>  (a.nationality || '').localeCompare(b.nationality || ''),
    },
    {
      title: t("Religion"),
      dataIndex: "religion",
      render: (value) => value ? t(value) : "N.A",
      sorter: (a, b) => (a.religion || '').localeCompare(b.religion || ''),
    },
    {
      title: t("Age"),
      dataIndex: "dob",
      sorter: false,
      render: (value) => value ? calculateAge(parseDMYToDate(value)) : ""
      
    },
    {
      title: t("Marital Status"),
      dataIndex: "marital",
      render: (value) => value ? t(value) : "N.A",
      sorter: (a, b) => (a.marital || '').localeCompare(b.marital || ''),
    },
    {
      title: t("Salary"),
      dataIndex: "salaries",
      sorter: (a, b) => a.salary - b.salary,
      render: (value) => {
        //  MYR: {value.MYR}
        return (
          <>
            {value.SGD ?  <div className="text-primary fw-bold p-2">{formatNumberWithCustomSymbol(value.SGD)}</div> : "N.A"}
          </>
        )
      },
    },
    {
      title: t("Experience (SG)"),//Value is either Yes or No or False
      dataIndex: "singapore_experience",
       render: (value) => (value ? t(value) : "N.A"),
      sorter: (a, b) => a["singapore_experience"] - b["singapore_experience"],
    },
    {
      title: t("Overseas Training"),//Value is either True or False
      dataIndex: "overseas_training",
      render: (value) => (value ? t("Yes") : t("No")),
      sorter: (a, b) => a["overseas_training"] - b["overseas_training"],
    }

  ];


  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);




  return (


    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar vendors={vendors} />

      <div className="page-wrapper">
        {(loadingForm || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                    Try Again
                  </button>*/}
              </div>
            )}
          </div>
        ) : (
          <>

            <div className="content container-fluid">
              {/* Page Header */} 
              <div className="page-header">
                <div className="content-page-header ">
                  <h5>{pageTitle}</h5>
                  <div className="list-btn">
                    <ul className="filter-list">
                      {
                        user.type == "agency" && user.company.is_premium && (
                          <li>
                            {/* button share to employer */}
                            <button className="btn btn-greys me-2" data-bs-toggle="modal" data-bs-target="#share_modal" onClick={console.log(selectedBiodata)} disabled={selectedBiodata.length == 0}>
                              <Icon.Share2 /> {t("Share")}
                            </button>

                          </li>
                        )
                      }
                      {/* <li>
                        <a
                          className="btn btn-filters w-auto popup-toggle me-2"
                          onClick={() => setShowFilter(!showFilter)}
                        >
                          <span className="me-2">
                          <Tooltip title="Filter" placement="bottom">
                          <img src={filterIcon} alt='filtericon'/>
                          </Tooltip>
                          </span>
                          {t("Filter")}{" "}
                        </a>
                      </li> */}
                    
                    </ul>
                  </div>
                </div>
              </div>
           <div className="row">
            {
                    user.type == "supplier" && data.length == 0 && (
                      <div className="text-center mt-5 py-5">
                        <div className="mb-4">
                          <div className="mb-3">
                            <i className="fas fa-female text-muted" style={{fontSize: '4rem', opacity: 0.3}}></i>
                          </div>
                          <h4 className="text-muted mb-2">{t("No Biodata Available")}</h4>
                          <p className="text-muted mb-4">{t("You don't have any biodata yet. Get started by creating your first biodata profile.")}</p>
                        </div>
                        <div className="d-flex gap-3 justify-content-center flex-wrap">
                          <Link className="btn btn-primary px-4 py-2 rounded-pill shadow-sm" to="biodata-form">
                            <i className="fas fa-plus me-2"></i>
                            {t("Add Biodata")}
                          </Link>
                          <Link className="btn btn-outline-primary px-4 py-2 rounded-pill" to="/biodata-form-extract">
                            <i className="fas fa-download me-2"></i>
                            {t("Extract Biodata")}
                          </Link>
                        </div>
                      </div>
                    )
                  }
                   {
                    user.type == "agency" && data.length == 0 && (
                      <div className="text-center mt-5 py-5">
                        <div className="mb-4">
                          <div className="mb-3">
                            <i className="fas fa-female text-muted" style={{fontSize: '4rem', opacity: 0.3}}></i>
                          </div>
                          <h4 className="text-muted mb-2">{t("No Biodata Available")}</h4>
                          <p className="text-muted mb-4">{t("You don't have any biodata yet. Start by inviting vendors to share their profiles with you.")}</p>
                        </div>
                        <div className="d-flex gap-3 justify-content-center flex-wrap">
                          <Link className="btn btn-primary px-4 py-2 rounded-pill shadow-sm" to="/vendor-invitations">
                            <i className="fas fa-user-plus me-2"></i>
                            {t("Invite Vendor")}
                          </Link>
                          <Link className="btn btn-outline-primary px-4 py-2 rounded-pill" to="/biodata-form-extract">
                            <i className="fas fa-download me-2"></i>
                            {t("Extract Biodata")}
                          </Link>
                        </div>
                      </div>
                    )
                  }
            </div>
          
              <div className="row">
                <div className="col-sm-12">
                  <SearchCard
                    keyword={keyword}
                    employer={employer}
                    employers={employers}
                    user={user}
                    handleSearchInputChange={handleSearchInputChange}
                    handleEmployerChange={handleEmployerChange}
                    handleSearchSubmit={handleSearchSubmit}
                    handleClearSearch={handleClearSearch}
                  />

                  {isMobileDevice() || screenWidth <= 576 ? (
                    <>
                      <AllBiodataMobile handlePageChange={handlePageChange} currentPage={currentPage} nextPage={nextPage} prevPage={prevPage} count={count} data={data} screenWidth={screenWidth} user={user} clickedBiodata={setclickedBiodata} vendorId={vendorId} selectedBiodata={selectedBiodata} setSelectedBiodata={setSelectedBiodata} onRefresh={fetchData} setIsBookOpen={setIsBookOpen}/>
                    </>
                  ) : (
                    <div className="p-3 bg-white rounded">
                      <div className=" card-table">
                        <div className="card-body vendors">
                          <div className="table-responsive table-hover table-striped">
                            <Table
                              pagination={{
                                  total: count,
                                  current: currentPage,
                                  showTotal: (length,range) => showTotal(t,length, range),
                                  onShowSizeChange: onShowSizeChange,
                                  itemRender:  (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                              }}
                              columns={columns}
                              dataSource={data}
                              scroll={{ x: "max-content" }}
                            />
                          </div>
                        </div>
                      </div>

                    </div>
                  )}
                  
                </div>
              </div>
          </div>
     
          </>
          )}

            { <Filter setShow={setShowFilter} show={showFilter} /> }

          {
            (user.type == 'supplier') && (
              <Broadcast clickedBiodata={clickedBiodata} />
            )
          }
           {
            (user.type == 'agency') && (
              <Share selectedBiodata={selectedBiodata} isOpen={isShareOpen} />  
            )
           }

          <BookEmployerBiodataShared biodata={clickedBiodata} isAccepted={null} fetchData={fetchData} isOpen={isBookOpen} />
          <ConfirmPublish refreshData={fetchData} selected_user={clickedBiodata} />
        </div >
      </div >
  );
};

export default BiodataForm;
